// Reads the Rails CSRF token from <meta name="csrf-token"> and builds JSON
// headers for every passkey fetch so forgery protection (ON) doesn't 422.
//
// NOTE: this is a plain helper, NOT a Stimulus controller. It lives under
// controllers/ (so it bundles via the relative import, not as a stray esbuild
// entrypoint) and must NOT be registered in index.js.
export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}

export function jsonHeaders() {
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-CSRF-Token": csrfToken(),
  };
}
